'use strict';

const {ProcessDisplayDialogData} = require('./../../dialogs/bpmn-display/bpmn-display.dialog');
const DIALOG_REGISTRY = require('../../dialogs/dialog.registry');

module.exports = (app) => app.directive('processDefinitionBpmn', /* @ngInject */ function () {
    return {
        restrict: 'E',
        scope: {
            /**
             * @type {boolean}
             */
            isOrder: '@',

            /**
             * @type {boolean}
             */
            isPurchaseRequisition: '@',
        },
        templateUrl: `./${BUILD_PATH}/process-definition-bpmn.directive.html`,
        controller: /* @ngInject */ function ($scope, dialogService, processDataService, translationService) {

            $scope.openDialog = openDialog;

            function openDialog() {
                const data = new ProcessDisplayDialogData(undefined, undefined, $scope.isOrder, $scope.isPurchaseRequisition);
                const title = translationService.translate(_('Freigabeprozess'))
                const config = {
                    title,
                    style: {
                        height: '80vh',
                        'max-height': '80vh',
                        width: '90vw',
                        'max-width': '90vw'
                    }
                };
                dialogService.open(DIALOG_REGISTRY.BPMN_DISPLAY.templatePath, DIALOG_REGISTRY.BPMN_DISPLAY.id, data, config)
            }
        }
    };
})
